﻿import $ from 'jquery';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import Utility from "../utility"

  export class AddRowBinder implements IBinder {
    public getElements(root: JQuery): JQuery {
      return root.find("[class*='et-add-row']");
    }

    public getBinding(element: JQuery): IBehaviorBinding {
      var addRowClass = element.attr("class").split(" ").filter((v: any) => {
        if (v.indexOf('et-add-row') !== -1)
          return true;
        else
          return false;
      })[0];

      var numRowsToAdd = "1";
      if (addRowClass != 'et-add-row')
        numRowsToAdd = addRowClass.match(/et-add-row-(\d*)/)[1]; //et-add-row-1 ... et-add-row-5 ... et-add-row

      var bindTo = "addRow.bind($data, " + numRowsToAdd + ")";

      return {
        bindingName: "click",
        bindTo: bindTo,
        behavior: {
          name: "addRow",
          build: data => (num, data, event) => {
            event.preventDefault();
            Utility.addRow(data, num, true);
            return true;
          }

        }
      }
    }
  }
